import { AppHypotheekbondPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../constants';

export default (): AppHypotheekbondPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_HYPOTHEEKBOND,
  variable: null,
});
